export default {
  state: {
    bounds: null,
    markers: [],
    layerUrl: null,
    highlightedFeature: null
  },
  mutations: {
    setBounds(state, bounds) {
      state.bounds = bounds;
    },
    setMarkers(state, markers) {
      state.markers = markers;
    },
    setLayerUrl(state, layerUrl) {
      state.layerUrl = layerUrl;
    },
    setHighlightedFeature(state, highlightedFeature) {
      state.highlightedFeature = highlightedFeature;
    }
  },
  actions: {
    fitBounds(context, bounds) {
      context.commit("setBounds", bounds);
    },
    showSearchResults(context, results) {
      context.commit(
        "setBounds",
        results.map(result => [result.lat, result.lng])
      );
      context.commit(
        "setMarkers",
        results.map(result => result.marker)
      );
    },
    showAddress(context, address) {
      context.commit("setMarkers", [address.marker]);
    },
    clearMarkers(context) {
      context.commit("setMarkers", []);
    },
    showLayerUrl(context, layerUrl) {
      context.commit("setLayerUrl", layerUrl);
    },
    highlightFeature(context, highlightedFeature) {
      context.commit("setHighlightedFeature", highlightedFeature);
    }
  },
  getters: {
    currentBounds: state => state.bounds,
    currentMarkers: state => state.markers,
    currentLayerUrl: state => state.layerUrl,
    currentHighlightedFeature: state => state.highlightedFeature
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/map_state.js